import { createSelector } from 'reselect'
import { get } from 'lodash'

import { NO_REFERALPAYER_DROPDOWN_VALUE } from 'src/constants'

import { addAllValue } from 'src/utils/v5/DataTrees'

const referralPayer = (state) => {
  return get(state, ['admin', 'referralPayer'], {})
}

export const referralPayerList$ = createSelector(
  referralPayer,
  ({ referralPayerList = [] }) => referralPayerList
)

export const referralPayerListWithAllAndNoRefSource$ = createSelector(
  referralPayerList$,

  (list) =>
    addAllValue({
      list: [...list, NO_REFERALPAYER_DROPDOWN_VALUE],
      convertList: true
    })
)

export const referralPayerListDropdown$ = createSelector(
  referralPayerList$,
  (list) =>
    list.map((item, key) => ({
      ...item,
      key,
      label: item.name,
      title: item.name,
      value: item.uuid
    }))
)
